export default __webpack_public_path__ + "static/media/home.75954902.svg";